import React from "react";
import PropTypes from "prop-types";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { pathOr } from "ramda";
import FaFileExcelO from "react-icons/lib/fa/file-excel-o";
import ReactTooltip from 'react-tooltip';
import { formatPercantage } from "utils/misc";

const getCallsWithoutVmail = phoneContacts =>
  pathOr(0, ["outgoing_call", "successes"], phoneContacts) -
  pathOr(0, ["left_voicemail", "successes"], phoneContacts);

const AnsweredCallsChart = ({ phoneContacts, onExport }) => (
  <div className="graph-container">
    <h4 className="graph-header">Voicemail Ratio</h4>
    <ReactTooltip />
    {onExport && (<div className="stat-export-icon" data-tip="Export" onClick={onExport}><FaFileExcelO /></div>)}
    <ResponsiveContainer height={200}>
      <PieChart>
        <Pie
          data={[
            {
              name: "Connected Calls",
              value: getCallsWithoutVmail(phoneContacts),
              fill: graphColors[1]
            },
            {
              name: "Left Voicemail",
              value: pathOr(0, ["left_voicemail", "successes"], phoneContacts),
              fill: graphColors[0]
            }
          ]}
          dataKey="value"
          nameKey="name"
          isAnimationActive={false}
        />
        <Legend />
        <Tooltip
          formatter={value =>
            `${value} -  ${formatPercantage(
              value,
              pathOr(0, ["outgoing_call", "successes"], phoneContacts)
            )}`
          }
        />
      </PieChart>
    </ResponsiveContainer>
  </div>
);

export default AnsweredCallsChart;

AnsweredCallsChart.propTypes = {
  phoneContacts: PropTypes.shape({
    outgoing_call: PropTypes.object,
    left_voicemail: PropTypes.object,
    success_total: PropTypes.number
  }),
  onExport: PropTypes.func
};
